// Office.onReady wrapper.
// All Office.js interaction MUST be funneled through adapters/office-js/
// once that layer exists (PR-3). For the mockup phase we only verify the
// host is alive — no document writes, no ContentControls, no fetches.

export interface OfficeHost {
  host: 'word' | 'browser'
  platform: string
}

export async function waitForOffice(): Promise<OfficeHost> {
  if (typeof window === 'undefined') {
    return { host: 'browser', platform: 'ssr' }
  }

  // When running outside Office (e.g. localhost preview without Word),
  // window.Office is undefined. We still mount the React tree so the
  // mockup can be reviewed in any browser.
  const officeGlobal = (window as unknown as { Office?: typeof Office }).Office
  if (!officeGlobal || typeof officeGlobal.onReady !== 'function') {
    return { host: 'browser', platform: 'standalone' }
  }

  return new Promise<OfficeHost>((resolve) => {
    officeGlobal.onReady((info) => {
      if (info?.host === Office.HostType.Word) {
        resolve({ host: 'word', platform: info.platform?.toString() ?? '' })
        return
      }
      resolve({ host: 'browser', platform: 'non-word-host' })
    })
  })
}
